<template>
  <div class="info">
      <slot></slot>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .info {
    height: fit-content;
    min-height: fit-content;
    max-height: fit-content;
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
  }
</style>
